import jsPDF from "jspdf";
import html2canvas from "html2canvas";

// Capture a DOM node and download it as a PDF file. Returns a Blob too.
// opts.width : force a fixed capture width (px) so the PDF is identical on mobile
//              and desktop (avoids the narrow/truncated result when sharing from a phone).
export async function elementToPdf(node, filename = "recu.pdf", opts = {}) {
  const { width } = opts;
  let target = node;
  let cleanup = null;

  if (width) {
    // Render an off-screen clone at a fixed desktop-like width so the layout
    // does not depend on the phone's narrow viewport.
    const holder = document.createElement("div");
    holder.style.cssText = `position:fixed;left:-10000px;top:0;width:${width}px;background:#ffffff;z-index:-1;`;
    const clone = node.cloneNode(true);
    clone.style.width = `${width}px`;
    clone.style.maxWidth = "none";
    clone.style.margin = "0";
    holder.appendChild(clone);
    document.body.appendChild(holder);
    await new Promise((r) => setTimeout(r, 200)); // let styles/images settle
    target = clone;
    cleanup = () => document.body.removeChild(holder);
  }

  try {
    const canvas = await html2canvas(target, {
      scale: 2,
      backgroundColor: "#ffffff",
      useCORS: true,
      ...(width ? { width, windowWidth: width } : {}),
    });
    const img = canvas.toDataURL("image/png");
    const pdf = new jsPDF({ orientation: "portrait", unit: "pt", format: "a4" });
    const pageW = pdf.internal.pageSize.getWidth();
    const pageH = pdf.internal.pageSize.getHeight();
    const margin = 24;
    const w = pageW - margin * 2;
    const h = (canvas.height * w) / canvas.width;
    let y = margin;
    if (h <= pageH - margin * 2) {
      pdf.addImage(img, "PNG", margin, y, w, h);
    } else {
      // paginate
      let remaining = h;
      let position = margin;
      pdf.addImage(img, "PNG", margin, position, w, h);
      remaining -= pageH - margin * 2;
      while (remaining > 0) {
        pdf.addPage();
        position = margin - (h - remaining);
        pdf.addImage(img, "PNG", margin, position, w, h);
        remaining -= pageH - margin * 2;
      }
    }
    const blob = pdf.output("blob");
    pdf.save(filename);
    return blob;
  } finally {
    if (cleanup) cleanup();
  }
}
